/* eslint-disable react-hooks/exhaustive-deps */
import { DependencyList, RefObject, useEffect } from 'react'

type ScrollIntoViewOptions = {
	delayMs?: number
}

export function useScrollIntoView<T extends HTMLElement>(
	ref: RefObject<T | null>,
	deps: DependencyList = [ ],
	options: ScrollIntoViewOptions = { },
) {
	const { delayMs = 120 } = options

	useEffect(() => {
		const timer = setTimeout(() => {
			ref.current?.scrollIntoView({
				behavior: 'smooth',
				block: 'end',
			})
		}, delayMs)

		// On iOS, the on-screen keyboard appears after our initial scroll
		// and shrinks the viewport, hiding the bottom of the element.
		// Re-scroll once the viewport has finished resizing.
		const viewport = window.visualViewport
		let debounceTimer: ReturnType<typeof setTimeout>
		const onResize = () => {
			clearTimeout(debounceTimer)
			debounceTimer = setTimeout(() => {
				ref.current?.scrollIntoView({
					block: 'end',
				})
			}, 120)
		}
		viewport?.addEventListener('resize', onResize)
		const cleanupTimer = setTimeout(() => {
			viewport?.removeEventListener('resize', onResize)
		}, 1500)

		return () => {
			clearTimeout(timer)
			clearTimeout(debounceTimer)
			clearTimeout(cleanupTimer)
			viewport?.removeEventListener('resize', onResize)
		}
	}, deps)
}
